// export const BASE_URL = "http://213.210.37.111:8080";
// export const BASE_URL = "http://localhost:9001";
// export const DOMAIN = "http://localhost:9001";
export const BASE_URL = "https://www.raipurbuilder.com/rbapi"; //new post api
export const DOMAIN = "https://www.raipurbuilder.com";
